import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import OuraNav from "../components/OuraNav";
import TimesheetView from "../components/TimesheetView";

const EmployeeTimesheetDetailPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [mode, setMode] = useState("created");

    return (
        <>
            <OuraNav links={[{ label: "Timesheets", href: "/employee/timesheets" }]} />
            <div style={{ maxWidth: "900px", margin: "0 auto", padding: "80px 20px 40px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                    <div style={{ display: "flex", gap: "8px" }}>
                        <button
                            onClick={() => setMode("created")}
                            style={{
                                background: mode === "created" ? "#1d1d1f" : "#f5f5f7",
                                color: mode === "created" ? "#fff" : "#1d1d1f",
                                border: "none", borderRadius: "8px", padding: "8px 16px",
                                fontSize: "13px", fontWeight: 600, cursor: "pointer"
                            }}
                        >
                            Non-Annotated
                        </button>
                        <button
                            onClick={() => setMode("live")}
                            style={{
                                background: mode === "live" ? "#1d1d1f" : "#f5f5f7",
                                color: mode === "live" ? "#fff" : "#1d1d1f",
                                border: "none", borderRadius: "8px", padding: "8px 16px",
                                fontSize: "13px", fontWeight: 600, cursor: "pointer"
                            }}
                        >
                            Annotated
                        </button>
                    </div>
                    <button
                        onClick={() => window.print()}
                        style={{ background: "#0071e3", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 16px", fontSize: "13px", fontWeight: 600, cursor: "pointer" }}
                    >
                        Print
                    </button>
                </div>

                <TimesheetView timesheetId={id} mode={mode} />
            </div>
        </>
    );
};

export default EmployeeTimesheetDetailPage;